<template>
  <div class="video-dialog">
    <CommonDialog
      :visible.sync="visible"
      width="800px"
      :before-close="handleClose"
      v-if="visible"
    >
    <!-- :poster="videoData.poster" -->
      <video
        class="video"
        :src="videoData.videoUrl"
        controls
        autoplay
      ></video>
    </CommonDialog>
  </div>
</template>

<script>
import CommonDialog from "@/components/CommonDialog";

export default {
  components: {
    CommonDialog,
  },
  data() {
    return {
      visible: false,
      videoData: {},
    };
  },
  methods: {
    init(obj) {
      this.videoData = obj;
      this.visible = true;
    },
    handleClose() {
      this.videoData = {};
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-dialog {
  .video {
    width: 100%;
    height: 500px;
  }
}
</style>
